import { SupportedLocales } from "@app/shared/utils/locales";
import { Textarea } from "@design-system/Inputs/Textarea";
import { FlexCol } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { ClassValue } from "@design-system/Utilities";
import { QuestionType } from "@generated/client/graphql";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { keys, RESOURCE_NAME } from "../../i18n";
import { type UpsertQuestionInput } from "../../types";

type NameAndDescriptionBlockProps = {
    questionInput: UpsertQuestionInput;
    locale: SupportedLocales;
    questionType?: QuestionType;
    onUpdate: (field: keyof UpsertQuestionInput, value: string) => void;
    onUpdateLocale: (
        field: "nameMultiLocale" | "descriptionMultiLocale",
        value: string,
    ) => void;
    className?: ClassValue;
};
export const NameAndDescriptionBlock = ({
    questionInput,
    locale,
    onUpdateLocale,
}: NameAndDescriptionBlockProps) => {
    const handleQuestionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        onUpdateLocale("nameMultiLocale", e.target.value);
    };

    const handleDescriptionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        onUpdateLocale("descriptionMultiLocale", e.target.value);
    };

    const { t } = useTranslation(RESOURCE_NAME);
    return (
        <FlexCol gap="4">
            <Text className="text-lg font-bold">
                {t(keys.create_questions_modal_question_label)}
            </Text>

            <Textarea
                className="resize-y"
                onChange={handleQuestionChange}
                rows={2}
                value={questionInput.nameMultiLocale?.[locale] ?? ""}
                placeholder={t(keys.create_questions_modal_question_name_label)}
                required={true}
            />
            <Textarea
                className="resize-y"
                onChange={handleDescriptionChange}
                rows={3}
                value={questionInput.descriptionMultiLocale?.[locale] ?? ""}
                placeholder={t(
                    keys.create_questions_modal_question_description_label,
                )}
            />
        </FlexCol>
    );
};
